
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cat/[[...categorySlug]]",
      function () {
        return require("private-next-pages/cat/[[...categorySlug]].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cat/[[...categorySlug]]"])
      });
    }
  